import { Avatar, Typography } from '@sanlam-glacier/app-common/components';
import styles from './app-bar-avatar.module.scss';
import { useAuth } from 'auth';
import { Theme } from '../theme/Theme';

export const AppBarAvatar = () => {
  const authApi = useAuth();
  const currentSignedInUser = authApi.getSignedInUser();
  const getLoggedInUserName = (): string => currentSignedInUser?.displayName ?? '';
  const initials = (): string =>
    `${currentSignedInUser?.fullName?.[0] ?? ''} ${currentSignedInUser?.familyName?.[0] ?? ''}`;
  return (
    <>
      <div className={styles.avatarContainer}>
        <Typography
          variant={Typography.VARIANT.B3}
          weight={Typography.WEIGHT.NORMAL}
          className={styles.userInfo}
        >
          {getLoggedInUserName()}
        </Typography>
        <div className={styles.userInfoUserIcon}>
          <Theme variant='secondary'>
            <Avatar alt='profile image' initials={initials()} />
          </Theme>
        </div>
      </div>
    </>
  );
};
